import { getIndexedId } from "@thegetty-private/rad-app-utils";
import { normalizeFieldToArray } from "@thegetty/linkedart.js";

const TOOK_PLACE_AT = "took_place_at";
const EQUIVALENT = "equivalent";

/**
 * Get the actor ids that are equivalent to the place
 *
 * @param {object} place
 * @returns
 */
export function getEquivalentPlaceIndexedIds(place) {
  let equivalent = normalizeFieldToArray(place, EQUIVALENT);
  equivalent = equivalent.map((eqiv) => getIndexedId(eqiv.id));
  return equivalent;
}

/**
 * Takes an Activity object and gets the place/location indexedId to pass
 * to the place getter
 *
 * @param {object} activity - the JSON-LD of the Activity object
 *
 * @return {string} the indexedId of the Place object of the exhibition activity
 *
 */
export function getPlaceIndexedId(activity) {
  let tookPlaceAt = normalizeFieldToArray(activity, TOOK_PLACE_AT);
  if (tookPlaceAt.length) {
    return getIndexedId(tookPlaceAt[0].id);
  }
}

/**
 * Gets the indexedIds for the HumanMadeObjects used as part of an Exhibition Activity
 *
 * @param {Object} activity - the Activity record for an exhibition
 *
 * @returns {Array} - the list of indexedIds of objects used by the exhibition
 */
export function getHumanMadeObjectsUsedByActivity(activity) {
  let used_specific = normalizeFieldToArray(activity, "used_specific_object");
  let indexedIds = [];

  // iterate over the members
  used_specific.forEach((memberSet) => {
    let members = normalizeFieldToArray(memberSet, "member");
    members.forEach((item) => {
      if (item != undefined) {
        indexedIds.push(getIndexedId(item.id));
      }
    });
  });
  return indexedIds;
}
